import React, {
  createContext,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

export type TableSort = { columnId: string; direction: 'asc' | 'desc' };

export const TableSortContext = createContext<TableSort | null>(null);

const ARIA_SORT = { none: 'none', asc: 'ascending', desc: 'descending' } as const;

function TableSortIndicator() {
  const ref = useRef<HTMLSpanElement | null>(null);
  const sort = useContext(TableSortContext);
  const [columnId, setColumnId] = useState<string | null>(null);

  // The library renders one shared sortIcon node in every header and never marks the active one
  useLayoutEffect(() => {
    setColumnId(ref.current?.closest('[data-sort-id]')?.getAttribute('data-sort-id') ?? null);
  }, []);

  const state = sort && columnId !== null && sort.columnId === columnId ? sort.direction : 'none';

  useEffect(() => {
    ref.current?.closest('[role="columnheader"]')?.setAttribute('aria-sort', ARIA_SORT[state]);
  }, [state]);

  return (
    <span ref={ref} className={`table-sort-indicator table-sort-indicator--${state}`}>
      <svg viewBox="0 0 8 12" aria-hidden="true" focusable="false">
        <path className="table-sort-indicator__up" d="M4 0L8 5H0Z" />
        <path className="table-sort-indicator__down" d="M4 12L0 7H8Z" />
      </svg>
    </span>
  );
}

export default TableSortIndicator;
